<section class="cta-section">
  <div class="container">
    <div class="cta-content">
      <h2>Ready to Drop In?</h2>
      <p>Join thousands of college students and young professionals<br />discovering the best parties in their area</p>
      <div class="store-btns">
        <a href="https://play.google.com/store/apps/details?id=com.dropaddy" class="store-btn store-btn-light">
          <i class="fa-brands fa-google-play"></i>
          <span class="btn-text">
            <small>Get it on</small>
            <strong>Google Play</strong>
          </span>
        </a>
        <a href="#" class="store-btn store-btn-dark">
          <i class="fa-brands fa-apple"></i>
          <span class="btn-text">
            <small>Download on the</small>
            <strong>App Store</strong>
          </span>
        </a>
      </div>
    </div>
  </div>
</section>
